module.exports = __webpack_public_path__ + "img/image-2.b5aca7cc.png";